import LiveBenchmarkRunner from "../../components/live-benchmark-runner";

export default <template>
  <LiveBenchmarkRunner @provider={{@outletArgs.provider}} />
</template>;
